const React = require('react')
const AccessibilityWidget = require('./src/components/accessibility-widget').default

// Must mirror gatsby-ssr.js exactly — a wrapPageElement that differs between
// the two produces a hydration mismatch on every page.
exports.wrapPageElement = ({ element }) =>
  React.createElement(
    React.Fragment,
    null,
    element,
    React.createElement(AccessibilityWidget)
  )

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
  var referrer = document.referrer;

  //if landing URL does not exist in local storage, set current pathname
  if (typeof window !== 'undefined' && window.localStorage && !window.localStorage.getItem('lNdUrL')) {
    window.localStorage.setItem('lNdUrL', location.href)
    window.localStorage.setItem('lNdUrLDtIme', new Date())
  }

  window.localStorage.setItem('crNtPaTH', location.href)
  window.localStorage.setItem('prevPaTHnAme', prevLocation ? prevLocation.href : null)


  window && window.CallTrk && window.CallTrk.swap();

}

// Initialize Vercel Analytics
exports.onClientEntry = () => {
  const { inject } = require('@vercel/analytics');
  inject();
}